// The auth screens' title block and the sent/done screens' hero icon
// (design/spec/auth/auth.html `.ftitle`, `.hero-ic`). The design's teal
// success hue has no token, so `ok` reads the status green (`--done`).
export function AuthHeading({ title, children }) {
  return (
    <div>
      <h1 className="font-display text-[27px] font-bold leading-[1.15] tracking-[-0.6px] max-[560px]:text-[24px]">
        {title}
      </h1>
      {children && (
        <p className="mt-2 text-[14px] leading-[1.55] text-muted-foreground [&_b]:font-semibold [&_b]:text-foreground">
          {children}
        </p>
      )}
    </div>
  )
}

export function HeroIcon({ icon: Icon, ok = false }) {
  return (
    <div
      className={
        ok
          ? "flex size-14 items-center justify-center rounded-2xl bg-done/10 text-done"
          : "flex size-14 items-center justify-center rounded-2xl bg-secondary text-foreground"
      }
    >
      <Icon className="size-[26px]" strokeWidth={1.8} />
    </div>
  )
}
